import * as React from "react";

import {MapViewerConfiguration} from "../../../config/map-viewer-configuration";
import {Item} from "semantic-ui-react";
import {Icon} from "../../../core/components/icon/icon";
import {PathUtils} from "../../../utils/path-utils";


export interface AdresseProps {
    adresse: string;
    mapViewerConfig: MapViewerConfiguration;
    heading?: string;
}

export class Adresse extends React.Component<AdresseProps, any> {
    constructor(props: AdresseProps) {
        super(props);
    }
    render(): React.ReactElement | null {
        const adressen = this.props.mapViewerConfig.adressen;
        const adresse = this.props.adresse;
        const heading = (this.props.heading? this.props.heading: "h2");
        let adresseMap: HashMap<string> = {};
        let aKey = "undefind";
        let itemClass = "";
        if (typeof adresse === "string") {
            aKey = adresse;
            adresseMap = {...adressen[aKey]};
            if(aKey === "rawi") {
                adresseMap.strong = adresseMap.title;
                adresseMap.title = "Kantonale Behörde";
                itemClass = "strong-title";
            }
        } else {
            aKey = adresse.class;
            adresseMap.adresse = "";
            if (adresse.class === "Grundbuchkreis"){
                adresseMap.title = "Grundbuchamt " + ("kreis" in adresse? adresse.kreis: "");
                adresseMap.adresse+= ("geschaeftsstelle" in adresse && adresse.geschaeftsstelle)?
                    "Geschäftsstelle "+ adresse.geschaeftsstelle + "\n": "";
            } else if (adresse.class === "Nachfuehrungskreis"){
                adresseMap.title = "Nachführungsgeometer";
                if ("nfg" in adresse) {
                    adresseMap.strong = adresse.nfg;
                }
                adresseMap.adresse+= ("unternehmen" in adresse? adresse.unternehmen+ "\n": "");
            } else if (adresse.class === "Bauamt" && "name" in adresse){
                adresseMap.title = "Kommunale Behörde (Leitbehörde)";
                adresseMap.strong = adresse.name;
                itemClass = "strong-title";
            } else if (adresse.class === "Gemeindekanzlei" && "name" in adresse){
                adresseMap.title = adresse.name;
            }
            adresseMap.adresse+= adresse.adresse;
            adresseMap.tel = adresse.tel;
            adresseMap.mail = adresse.mail;
            adresseMap.webseite = adresse.webseite;

        }
        if (!adresseMap) {
            return null;
        }
        return(
            <Item key={aKey} className={itemClass}>
                <Item.Content>
                    <Item.Header as={heading}>{adresseMap.title}</Item.Header>
                    <Item.Description>
                        <p>
                            {adresseMap.strong? (<span><strong>{adresseMap.strong}</strong><br /></span>): ""}
                            {adresseMap.adresse.split("\n").map(
                                (item, key) => (<span key={key}>{item}<br /></span>))}
                        </p>
                        <p>
                            {(adresseMap.tel) ? (
                                <span><a href={"tel:+41"+ adresseMap.tel
                                    .substr(1).replace(/ /g,"0")}>
                                    <Icon name={"phone_receiver2"} selected /> <span className={"linked"}>
                                        {adresseMap.tel}</span></a><br /></span>
                            ) : null }
                            {(adresseMap.mail) ? (
                                <span><a href={"mailto:"+ adresseMap.mail}
                                    rel={"noreferrer"}>
                                    <Icon name={"mail"} selected /> <span className={"linked"}>
                                        {adresseMap.mail.length < 25? adresseMap.mail: "E-Mail"}</span></a><br /></span>
                            ) : null }
                            {(adresseMap.webseite) ? (
                                <span><a href={adresseMap.webseite} target={"_blank"}
                                    rel={"noreferrer"}>
                                    <Icon name={"navigate_right"} /> <span className={"linked"}>
                                        {PathUtils.readableUrl(adresseMap.webseite)}
                                    </span></a><br /></span>
                            ) : null }
                        </p>
                    </Item.Description>
                </Item.Content>
            </Item>
        );
    }
}
